enum GoogleMapIconTypesEnum {
  Default = 'Default',
  DefaultSelected = 'DefaultSelected',
  Small_UPS = 'Small_UPS',
  Big_UPS = 'Big_UPS',
}

export default GoogleMapIconTypesEnum;
